export default __webpack_public_path__ + "static/media/united-kingdom.15d2e407.svg";